import { useState } from "react";
import axios from "axios";
import { API } from "../App";
import { toast } from "sonner";
import {
  Box,
  Card,
  CardContent,
  TextField,
  Button,
  Typography,
  Container,
  Stack,
  CircularProgress,
} from '@mui/material';
import Logo from "../components/Logo";

export default function Login({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${API}/auth/login`, { email, password });
      
      // Verificar se está bloqueado
      if (response.data.blocked) {
        onLogin(null, response.data.user || {}, true, response.data.company);
      } else {
        toast.success("Login realizado com sucesso!");
        onLogin(response.data.access_token, response.data.user, false, null);
      }
    } catch (error) {
      // Verificar se o erro é de bloqueio
      if (error.response?.status === 403 && error.response?.data?.blocked) {
        onLogin(null, {}, true, error.response.data.company);
      } else {
        toast.error(error.response?.data?.message || error.response?.data?.detail || "Erro ao fazer login");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleDemoLogin = async () => {
    setLoading(true);
    try {
      const response = await axios.post(`${API}/auth/login`, {
        email: "joao.silva@empresademo.com",
        password: "senha123"
      });
      
      if (response.data.blocked) {
        onLogin(null, response.data.user || {}, true, response.data.company);
      } else {
        toast.success("Login demo realizado com sucesso!");
        onLogin(response.data.access_token, response.data.user, false, null);
      }
    } catch (error) {
      if (error.response?.status === 403 && error.response?.data?.blocked) {
        onLogin(null, {}, true, error.response.data.company);
      } else {
        toast.error("Erro ao fazer login demo. Use: igor@stocksistema.com / admin@2024 (ADM) ou joao.silva@empresademo.com / senha123 (Empresa)");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        overflow: 'hidden',
        background:
          'radial-gradient(1100px 600px at 10% 0%, rgba(14,165,233,0.22), transparent 60%),' +
          'radial-gradient(900px 500px at 90% 100%, rgba(56,189,248,0.18), transparent 60%),' +
          'linear-gradient(135deg, #0f172a 0%, #0b1426 60%, #0f172a 100%)',
      }}
    >
      {/* Brand keywords subtitle bar */}
      <Box
        sx={{
          position: 'absolute',
          bottom: 24,
          left: 0,
          right: 0,
          textAlign: 'center',
          color: 'rgba(255,255,255,0.55)',
          fontSize: '0.7rem',
          letterSpacing: '3px',
          fontWeight: 500,
        }}
      >
        CONTROLE • ORGANIZAÇÃO • CRESCIMENTO • INTEGRAÇÃO
      </Box>

      <Container maxWidth="sm" sx={{ position: 'relative', zIndex: 1 }}>
        <Card
          elevation={0}
          sx={{
            borderRadius: 3,
            overflow: 'visible',
            backdropFilter: 'blur(18px)',
            backgroundColor: 'rgba(255,255,255,0.97)',
            border: '1px solid rgba(255,255,255,0.4)',
            boxShadow: '0 24px 60px -12px rgba(2,6,23,0.45)',
          }}
        >
          <CardContent sx={{ p: { xs: 3, sm: 5 } }}>
            <Stack spacing={3} alignItems="center">
              {/* Logo */}
              <Box sx={{ mb: 0.5 }}>
                <Logo variant="full" size={64} />
              </Box>

              {/* Title */}
              <Box textAlign="center">
                <Typography variant="body2" color="text.secondary" sx={{ letterSpacing: '0.5px' }}>
                  Sistema de Gestão • PDV • Estoque • Fiscal
                </Typography>
              </Box>

              {/* Form */}
              <Box
                component="form"
                onSubmit={handleLogin}
                sx={{ width: '100%' }}
              >
                <Stack spacing={2.5}>
                  <TextField
                    label="Email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    fullWidth
                    autoComplete="email"
                    inputProps={{ 'data-testid': 'email-input' }}
                  />

                  <TextField
                    label="Senha"
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    fullWidth
                    autoComplete="current-password"
                    inputProps={{ 'data-testid': 'password-input' }}
                  />

                  <Button
                    type="submit"
                    variant="contained"
                    size="large"
                    fullWidth
                    disabled={loading}
                    sx={{ py: 1.5 }}
                  >
                    {loading ? <CircularProgress size={24} color="inherit" /> : 'Entrar'}
                  </Button>

                  <Button
                    variant="text"
                    onClick={handleDemoLogin}
                    disabled={loading}
                    fullWidth
                    sx={{ textTransform: 'none' }}
                  >
                    Login Demo Empresa
                  </Button>
                </Stack>
              </Box>
            </Stack>
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
}
